import { render, staticRenderFns } from "./WsInfoHasMany.vue?vue&type=template&id=09255493&"
import script from "./WsInfoHasMany.vue?vue&type=script&lang=js&"
export * from "./WsInfoHasMany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports